import LayoutPageHero from '@/components/Layout/PageHero'
import PageBreadcrumb from '@/components/Pages/PageBreadcrumb'

interface IPageHeroProps {
    title: string
    scriptTitle?: string
    slug?: string
}

/**
 * Cabeçalho das páginas do CMS (/p/[slug]): o PageHero da loja com a trilha da árvore de páginas e as medidas próprias
 * (altura mínima em vez de fixa, título menor). Usado pela central de ajuda (sem trilha) e pela página do CMS.
 */
const PageHero: React.FC<IPageHeroProps> = ({ title, scriptTitle, slug }) => {
    return (
        <LayoutPageHero
            color="bg-tertiary-green"
            containerClassName="container relative flex flex-row min-h-[205px] py-8 justify-left items-center z-40 mt-24"
            contentClassName="lg:ml-8 flex flex-col w-full"
            breadcrumbs={slug && <PageBreadcrumb slug={slug} variant="light" />}
            titleClassName="text-white text-[40px] max-md:text-[26px] font-semibold ml-4 md:ml-8 title-head-size leading-tight"
            title={
                <>
                    {title}
                    {scriptTitle && (
                        <>
                            {' '}
                            <span className="font-eldwin-script text-[48px] max-md:text-[36px]">
                                <br className="lg:hidden" />
                                {scriptTitle}
                            </span>
                        </>
                    )}
                </>
            }
        />
    )
}

export default PageHero
